import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";

@Component({
  selector: 'app-honours',
  templateUrl: './honours.component.html',
  styleUrls: ['./honours.component.scss']
})
export class HonoursComponent implements OnInit {


  honoursList: any = "";

  constructor(private allpagesService: AllPageService,) { }

  ngOnInit() {
    this.allpagesService.getHistoryHonours().then((data) => {
			this.honoursList = data; 
			console.warn(this.honoursList);
		});
  }

}
